import type { IChannel } from "containers/Channels/types";
import type { ChannelParams } from "containers/TermFormContainer";
import { useTranslation } from "react-i18next";

import ChannelBaseColumnsRecap from "../ChannelBaseColumnsRecap";
import ChannelsMilestonesRecap from "../ChannelsMilestonesRecap";
import FormulaScopeChip from "../FormulaScopeChip";
import { formatTypeRecapLabel } from "../formatTypeRecap";
import styles from "./style.module.scss";

type FormatOverridesRecapProps = {
    overrides: ChannelParams[];
    fullChannelData: IChannel | undefined;
    formatTypeNamesById: ReadonlyMap<number, string>;
    showBaseColumns?: boolean;
};

const FormatOverridesRecap = ({
    overrides,
    fullChannelData,
    formatTypeNamesById,
    showBaseColumns = true,
}: FormatOverridesRecapProps) => {
    const [t] = useTranslation();

    if (overrides.length === 0) return null;

    return (
        <div className={styles["format-overrides"]}>
            <span className={styles["format-overrides-label"]}>{t("TermRecap.FormatFormulas")}</span>
            {overrides.map((override) => {
                const formatTypeId = override.formatTypeId;
                if (formatTypeId == null) return null;
                const hasMilestones = Array.isArray(override.data) && override.data.length > 1;
                return (
                    <div
                        className={styles["format-override"]}
                        key={`format-override-${override.channelId}-${formatTypeId}`}
                    >
                        <FormulaScopeChip
                            variant="format"
                            label={formatTypeRecapLabel(formatTypeId, formatTypeNamesById)}
                        />
                        {showBaseColumns && (
                            <ChannelBaseColumnsRecap
                                channel={override}
                                fullChannelData={fullChannelData}
                                hasMilestones={hasMilestones || !!fullChannelData?.hasMilestones}
                            />
                        )}
                        <ChannelsMilestonesRecap
                            chosenChannel={override}
                            fullChannelData={fullChannelData}
                            hasMilestones={hasMilestones}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default FormatOverridesRecap;
